import { Stack, Typography } from "@mui/material";
import { DIRECTION_TO_LABEL_KEY_MAP } from "Components/Shared/Transactions/transactionsUtils";
import type { TransactionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import {
  getTransactionRefundState,
  refundStateToColor,
  refundStateToLabelKey,
  transactionStatusToColor,
  type ViewerTransactionDirection,
} from "Utils/TransactionUtils";

type Props = {
  direction: ViewerTransactionDirection;
  publicID: string;
  status: TransactionStatus;
  isRefund?: boolean;
  relatedTransactionStatus?: TransactionStatus | null;
};

export const TransactionDetails = ({
  direction,
  publicID,
  status,
  isRefund,
  relatedTransactionStatus,
}: Props) => {
  const { t } = useResource();

  const directionLabel = t(DIRECTION_TO_LABEL_KEY_MAP[direction]);
  const displayTitle = `${directionLabel} - ${publicID}`;

  // ZS-1676: a refunded original stays Success — surface the refund state instead of the bare status.
  const refundState = getTransactionRefundState({
    status,
    isRefund,
    relatedTransactionStatus,
  });

  const statusLabel = refundState
    ? t(refundStateToLabelKey[refundState])
    : t(Resources.Transactions.TransactionStatus[status]);

  const getStatusColor = (): string | undefined => {
    if (refundState) {
      return refundStateToColor[refundState];
    }

    if (status) {
      return transactionStatusToColor[status];
    }

    return undefined;
  };
  const statusColor = getStatusColor();

  return (
    <Stack component="span" gap={0.5} textAlign="left">
      <Typography fontSize="0.875rem">{displayTitle}</Typography>
      <Typography fontSize="0.75rem" color={statusColor}>
        {statusLabel}
      </Typography>
    </Stack>
  );
};
